import '../../css/junglebackground.css'

const JungleBackground = () => {
    return(<>
        <img src="/assets/jungle/bush1.png" alt="" className='bush1'/>
        <img src="/assets/jungle/bush2.png" alt="" className='bush2'/>

        <img src="/assets/jungle/ceil1.png" alt="" className='ceil1'/>
        <img src="/assets/jungle/ceil2.png" alt="" className='ceil2'/>
        <img src="/assets/jungle/ceil3.png" alt="" className='ceil3'/>
        <img src="/assets/jungle/ceil4.png" alt="" className='ceil4'/>

        <img src="/assets/jungle/tree.png" alt="" className='tree'/>

        <img src="/assets/jungle/bird.png" alt="" className='jungle-bird'/>

        <img src="/assets/jungle/sun3.png" alt="" className='sun3'/>
        <img src="/assets/jungle/sun2.png" alt="" className='sun2'/>
        <img src="/assets/jungle/sun1.png" alt="" className='sun1'/>
        
        <img src="/assets/jungle/background.png" alt="" className='jungle-background'/>
        
    </>)
}

export default JungleBackground;